interface RightArrowInChipsFiltersProps {
    color: string;
    onClick: () => void;
    isVisibleOnHover?: boolean;
    additionalClassName?: string;
    svgAdditionalClassName?: string;
    minHeight?: string;
    isHorizontalList?: boolean;
    width?: string;
    height?: string;
    isArrowHidden?: boolean;
}

export const RightArrowInChipsFilters = ({
    color, onClick,
    isVisibleOnHover = true,
    additionalClassName,
    svgAdditionalClassName,
    minHeight = '',
    isHorizontalList = false,
    width = '20px',
    height = '20px',
    isArrowHidden = false
}: RightArrowInChipsFiltersProps) => {
    return (
        <>
            {isArrowHidden ? (
                <div className={`flex justify-center items-center
                cursor-pointer 
                bg-transparent
               ${isHorizontalList ? 'right-0 top-0' : 'right-[26px] top-0'} 
               z-30 rounded-[4px]
               ${isVisibleOnHover ? 'opacity-70 hover:opacity-100' : 'opacity-0'} 
               ${additionalClassName}
               ${minHeight}`}
                    style={{
                        minWidth: `${width}`,
                        minHeight: `${height}`,
                        maxHeight: `${height}`
                    }}
                />
            ) : (
                <div className={`flex justify-center items-center
             cursor-pointer 
            bg-base090 relative 
            ${isHorizontalList ? 'right-0 top-0' : 'right-[26px] top-0'} 
            z-30 rounded-[4px]
            ${isVisibleOnHover ? 'opacity-70 hover:opacity-100' : 'opacity-0'} 
            ${additionalClassName}
            ${minHeight}`}
                    onClick={onClick}
                    style={{
                        minWidth: `${width}`,
                        minHeight: `${height}`,
                        maxHeight: `${height}`
                    }}
                >
                    {isHorizontalList ? (
                        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.665061 0.279528C0.406621 0.602098 0.457192 1.07424 0.778014 1.33409L9.00813 8L0.778015 14.6659C0.457192 14.9258 0.406622 15.3979 0.665062 15.7205C0.923502 16.043 1.39309 16.0939 1.71391 15.834L9.94403 9.16813C10.6853 8.56772 10.6853 7.43228 9.94403 6.83187L1.71391 0.16596C1.39309 -0.0938876 0.923502 -0.0430414 0.665061 0.279528Z"
                                fill={color}
                            />
                        </svg>

                    ) : (
                        <svg width="7" height="12" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${svgAdditionalClassName}`}>
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.165061 0.279528C-0.0933791 0.602098 -0.0428082 1.07424 0.278014 1.33409L8.50813 8L0.278015 14.6659C-0.0428076 14.9258 -0.0933784 15.3979 0.165062 15.7205C0.423502 16.043 0.893088 16.0939 1.21391 15.834L9.44403 9.16813C10.1853 8.56772 10.1853 7.43228 9.44403 6.83187L1.21391 0.16596C0.893087 -0.0938876 0.423502 -0.0430414 0.165061 0.279528Z"
                                fill={color}
                            />
                        </svg>
                    )}
                </div>
            )}
        </>
    )
}
